import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    container: {
        height: '100vh',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: 0,
        left: 0,
    },
    logotypeContainer: {
        backgroundColor: theme.palette.primary.main,
        width: '60%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            width: '50%',
        },
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    },
    logotypeImage: {
        width: 600,
        // marginBottom: theme.spacing(4)
    },
    logotypeText: {
        color: 'white',
        fontWeight: 500,
        fontSize: 48,
        [theme.breakpoints.down('md')]: {
            fontSize: 48,
        },
    },
    customFormContainer: {
        width: '40%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        overflow: 'auto',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            width: '50%',
            overflow: 'visible',
        },
    },
    formContainer: {
        width: '40%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            width: '50%',
            overflow: 'visible',
        },
    },
    form: {
        width: 320,
        position: 'absolute',
        top: '20%',
        [theme.breakpoints.down('md')]: {
            top: '12%',
        },
    },
    customForm: {
        width: 320,
        position: 'absolute',
        top: '30%',
    },
    tab: {
        fontWeight: 400,
        fontSize: 18,
    },
    formTitle: {
        fontWeight: 500,
        textAlign: 'center',
        marginTop: theme.spacing(4),
    },
    greeting: {
        fontWeight: 500,
        textAlign: 'center',
        marginTop: theme.spacing(4),
    },
    subGreeting: {
        fontWeight: 500,
        textAlign: 'center',
        marginTop: theme.spacing(2),
    },
    googleButton: {
        marginTop: theme.spacing(6),
        boxShadow: theme.customShadows.widget,
        backgroundColor: 'white',
        width: '100%',
        textTransform: 'none',
    },
    googleButtonCreating: {
        marginTop: 0,
    },
    googleIcon: {
        width: 30,
        marginRight: theme.spacing(2),
    },
    creatingButtonContainer: {
        marginTop: theme.spacing(2.5),
        height: 46,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    createAccountButton: {
        height: 46,
        textTransform: 'none',
    },
    formDividerContainer: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4),
        display: 'flex',
        alignItems: 'center',
    },
    formDividerWord: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    formDivider: {
        flexGrow: 1,
        height: 1,
        backgroundColor: theme.palette.text.hint + '40',
    },
    errorMessage: {
        textAlign: 'center',
    },
    textFieldUnderline: {
        '&:before': {
            borderBottomColor: theme.palette.primary.light,
        },
        '&:after': {
            borderBottomColor: theme.palette.primary.main,
        },
        '&:hover:before': {
            borderBottomColor: `${theme.palette.primary.light} !important`,
        },
    },
    textField: {
        borderBottomColor: theme.palette.background.light,
    },
    formButtons: {
        width: '100%',
        marginTop: theme.spacing(4),
        display: 'flex',
        // justifyContent: "space-between", needed when forgot password is displayed
        justifyContent: 'center',
        alignItems: 'center',
    },
    forgetButton: {
        textTransform: 'none',
        fontWeight: 400,
    },
    loginLoader: {
        marginLeft: theme.spacing(4),
    },
    copyright: {
        marginTop: theme.spacing(6),
        whiteSpace: 'nowrap',
        fontSize: '0.9rem',
        position: 'absolute',
        top: '90%',
        [theme.breakpoints.up('md')]: {
            bottom: theme.spacing(2),
        },
    },
    generalInformation: {
        textAlign: 'center',
        position: 'absolute',
        top: '84%',
        fontSize: '0.9rem',
        // hide on small devices
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    generalInformationLink: {
        '&:link': {
            color: theme.palette.quaternary.main,
            fontWeight: 'bold',
            textDecoration: 'none',
        },
    },
    youtubeLink: {
        '&:link': {
            color: theme.palette.quaternary.main,
            fontWeight: 'bold',
        },
        '&:visited': {
            color: theme.palette.quaternary.main,
        },
    },
    backButtonContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '16px',
    },
    backButtonLink: {
        color: theme.palette.primary.main,
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
}));
